import styled from '@emotion/styled'

export const ModalContentContainer = styled.div`
	padding: 20px 0;
`
